/* eslint-disable react/no-unstable-nested-components */
import { Tabs } from 'antd';
import React, { FC } from 'react';
import { getContextStores } from '../../../context';
import Summary from './Summary';
import PlanResponseLogTable from '../../../components/atoms/PlanResponseLogTable';
import { PlanResponseLog } from '../../../config/types';

const PlannedTwinIDUpdateToolDetails: FC = () => {
  /* Context */
  const contextStores = getContextStores();
  const { plannedTwinIDUpdateState } = contextStores;
  const { plannedUpdatedPlannedTwinID } = plannedTwinIDUpdateState || {};
  const {
    errorCount,
    warningCount,
    infoCount,
    info,
    errors,
    warnings,
  } = plannedUpdatedPlannedTwinID?.logging || {};

  const renderLogs = (logs?: PlanResponseLog[]) => {
    if (!logs) return null;

    return <PlanResponseLogTable logs={logs} />;
  };

  const tabItems = [
    {
      label: 'Summary',
      key: 'summary',
      children: <Summary />,
    },
    {
      label: `Errors (${errorCount || 0})`,
      key: 'errors',
      children: renderLogs(errors),
    },
    {
      label: `Warnings (${warningCount || 0})`,
      key: 'warnings',
      children: renderLogs(warnings),
    },
    {
      label: `Info (${infoCount || 0})`,
      key: 'info',
      children: renderLogs(info),
    },
  ];

  return (
    <Tabs
      style={{ flex: 1 }}
      defaultActiveKey="1"
      items={tabItems}
    />
  );
};

export default PlannedTwinIDUpdateToolDetails;
